const routes = [
    {
        name: 'bancointer.pagamentos.boletos',
        path: '/banco_inter/pagamentos_boletos',
        alias: '/banco_inter/pagamentos_boletos/index',
        component: () => import('../views/Listar')
    },
    {
        path: '/banco_inter/pagamentos_boletos/pagar',
        component: () => import('../views/Pagar')
    },
    {
        path: '/banco_inter/pagamentos_boletos/visualizar/:codigoTransacao',
        component: () => import('../views/Visualizar')
    },
    
]

export default routes
